export default __webpack_public_path__ + "static/favicon-white-6e768239f8e3044166b3145d2aef9d45.png";